import BaseUseCase from "../../base_use_case.js";

class UploadGalleryImageUseCase extends BaseUseCase {

  execute(image) {
    let formData = new FormData();
    formData.append("gallery_image[attachment]", image)

    return this.httpClient({
      ...this.requestConfig(),
      method: "post",
      url: `/api/v1/assets/gallery_images`,
      data: formData,
    });
  }

  requestConfig() {
    let config = super.requestConfig();
    config.headers["Content-Type"] = "application/x-www-form-urlencoded";
    return config;
  }
}

const instance = new UploadGalleryImageUseCase();
export default instance;